export default {
  computed: {
    userLink() {
      if (this.info.userRole === 2 && this.info.userSlug !== '365-team') {
        return `/instructors/${this.info.userSlug}/`;
      }

      if (this.info.userRole === 2 && this.info.userSlug === '365-team') {
        return '/instructors/';
      }

      return `/profile/${this.info.userSlug}/`;
    },
    projectLink() {
      if (this.$config.project === 'lms') {
        return this.$config.siteUrl;
      }

      return this.$config.lmsUrl;
    },
    isInactiveLink() {
      if (this.$config.platform === 'ds') {
        return this.info.userRole === 2 && !this.info.userInstructorPage && this.info.userSlug !== '365-team';
      }

      return this.info.userRole === 2;
    },
    isLocalLink() {
      if (this.$config.project === 'lms') {
        return this.info.userRole === 1;
      }

      return this.info.userRole === 2;
    },
  },
};
